import PropTypes from "prop-types";
import { css } from "@emotion/react";

import Avatar from "@/components/Avatar";

import PlatformIcon from "@/assets/svg/platform.svg";
import DbmsIcon from "@/assets/svg/dbms.svg";

Header.propTypes = {};

function Header() {
  return (
    <div css={header}>
      <div css={brand}>
        <div>
          <img src="/images/image-brand.png" alt="verti-pit" />
        </div>
        <span className="version"></span>
      </div>
      <div css={aside}>
        <div css={status}>
          <div css={connect}>Connected</div>
          <ul css={device}>
            <li>
              <PlatformIcon />
              <div>Platform</div>
            </li>
            <li>
              <DbmsIcon />
              <div>DBMS</div>
            </li>
          </ul>
        </div>
        <div css={account}>
          <Avatar />
        </div>
      </div>
    </div>
  );
}

const header = (theme) => css`
  position: fixed;
  display: flex;
  justify-content: space-between;
  z-index: ${theme.zIndex.LEVEL_5};
  max-width: 100%;
  background: #fff;
  box-shadow: 0px 5px 15px #0000000d;
  width: 100%;
  height: 60px;
  min-width: 1900px;
`;

const brand = (theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  width: 220px;

  svg {
    width: 97px;
  }

  .version {
    font-size: 12px;
    color: ${theme.color.primary};
    padding-bottom: 4px;
  }
`;

const aside = (theme) => css`
  display: flex;
  align-items: center;
  padding: 0px 20px;
`;

const status = (theme) => css`
  display: flex;
  align-items: center;
`;

const connect = (theme) => css`
  background-color: ${theme.color.primary};
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
  padding: 2px 13px;
  cursor: default;
  user-select: none;
  margin-right: 22px;
`;

const device = (theme) => css`
  li {
    display: inline-flex;
    position: relative;
    font-weight: 700;
    align-items: center;
  }

  li::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -15px;
    width: 1px;
    height: 16px;
    background-color: #cccccc;
  }

  li:last-child::after {
    display: none;
  }

  li + li {
    margin-left: 30px;
  }

  li svg {
    margin-right: 10px;
    fill: ${theme.color.primary};
    width: 18.823px;
  }
`;

const account = (theme) => css`
  margin-left: 40px;
`;

export default Header;
